import React, {useState} from 'react'
import { NavLink } from "react-router-dom";
import home2 from '../assets/icons/home2.svg'


function Navbar() {
  const [outsideHome, setOutHome] = useState(false);

  return (
    <header className='sticky pt-6 bg-none z-20 w-full'>
        <div className=' flex items-center justify-around'>
            <NavLink  onClick={() => setOutHome(false)} to="/" className=' w-10 h-10  items-center justify-center flex font-bold '>
                <img className='text-teal-400' src={home2} />   
            </NavLink>

            <nav className='space-x-6 '>
                <NavLink to='/about' onClick={() => setOutHome(true)}
                    className={({isActive}) => `${isActive ? 'text-blue-500 drop-shadow ' : "text-black"}  tracking-widest`}>
                    About
                </NavLink>
                <NavLink to='/project' onClick={() => setOutHome(true)} 
                    className={({isActive}) => `${isActive ? 'text-blue-500 drop-shadow' : "text-black"}  tracking-widest`}>
                    Projects
                </NavLink>
            </nav>
        </div>
    </header>
  )
}

export default Navbar;